import { makeApi } from "@zodios/core";
import { z } from "zod";

import { zendeskTicketDtoSchema } from "@/types/backoffice/dto/zendesk/zendesk-ticket-dto.ts";

export const backofficeZendeskApi = makeApi([
  {
    method: "get",
    path: "/site/:siteId/tickets",
    alias: "findZendeskTickets",
    parameters: [
      {
        type: "Path",
        schema: z.number(),
        name: "siteId",
      },
    ],
    response: z.array(zendeskTicketDtoSchema),
  },
]);
